var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback, useState } from "react";
/**
 * A hook that implements the base functionality for expanding different tree
 * items.
 *
 * @param defaultExpandedIds - Either a list of tree item ids to be expanded by
 * default or a function that will return the list of tree item ids to be
 * expanded by default
 * @returns An object containing props that can be passed to the `Tree`
 * component to handle the expansion state within the tree.
 */
export function useTreeItemExpansion(defaultExpandedIds) {
    var _a = useState(defaultExpandedIds), expandedIds = _a[0], setExpandedIds = _a[1];
    var onItemExpansion = useCallback(function (itemId, expanded) {
        setExpandedIds(function (expandedIds) {
            var i = expandedIds.indexOf(itemId);
            if (i === -1 && expanded) {
                return __spreadArray(__spreadArray([], expandedIds, true), [itemId], false);
            }
            if (i !== -1 && !expanded) {
                var nextIds = expandedIds.slice();
                nextIds.splice(i, 1);
                return nextIds;
            }
            return expandedIds;
        });
    }, []);
    var onMultiItemExpansion = useCallback(function (itemIds) {
        setExpandedIds(itemIds);
    }, []);
    return {
        expandedIds: expandedIds,
        onItemExpansion: onItemExpansion,
        onMultiItemExpansion: onMultiItemExpansion,
    };
}
//# sourceMappingURL=useTreeItemExpansion.js.map